import { MsalProvider } from "@azure/msal-react"
import { PublicClientApplication } from "@azure/msal-browser"
import { ThemeProvider, createTheme } from "@mui/material/styles"
import { CssBaseline, Container, Typography, AppBar, Toolbar, Paper } from "@mui/material"
import { Dashboard } from "@mui/icons-material"
import { msalConfig } from "./config/authConfig"
import PowerBIDashboard from "./PowerBIDashboard"
import "./styles/powerbi-embed.css" // Import Power BI styles

const msalInstance = new PublicClientApplication(msalConfig)

const theme = createTheme({
  palette: {
    mode: "light",
    primary: {
      main: "#1976d2",
    },
    secondary: {
      main: "#dc004e",
    },
    background: {
      default: "#f5f5f5",
    },
  },
  typography: {
    h4: {
      fontWeight: 600,
    },
  },
  components: {
    MuiCard: {
      styleOverrides: {
        root: {
          boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
          borderRadius: 12,
        },
      },
    },
  },
})

function App() {
  return (
    <MsalProvider instance={msalInstance}>
      <ThemeProvider theme={theme}>
        <CssBaseline />

        <AppBar position="static" elevation={0}>
          <Toolbar>
            <Dashboard sx={{ mr: 2 }} />
            <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
              Business Intelligence Dashboard
            </Typography>
          </Toolbar>
        </AppBar>

        <Container maxWidth="xl" sx={{ py: 4 }}>
          <Paper sx={{ p: 3, mb: 3 }}>
            <Typography variant="h4" component="h1" gutterBottom>
              Power BI Analytics 1.4v
            </Typography>
            <Typography variant="body1" color="text.secondary">
              Interactive business intelligence dashboard powered by Microsoft Power BI
            </Typography>
          </Paper>

          <PowerBIDashboard title="Sales & Performance Dashboard" height="700px" />
        </Container>
      </ThemeProvider>
    </MsalProvider>
  )
}

export default App
